<template>
  <div>
    <page-main :disabled="disabled" :table-data="table" :params="params" :loading="loading" @submit="handleSubmit" />
    <p></p>
    <js-pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        align="right"
        size="sm"
        @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  components: {
    'PageMain': () => import('./components/main')
  },
  props: {
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  watch: {
    params: {
      handler () {
        if (this.autoLoad) {
          this.handleSubmit()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0
      }
    }
  },
  methods: {
    load (params) {
      this.handleSubmit(params)
    },
    // 分页查询
    handlePaginationChange (val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.handleSubmit(this.params)
      })
    },
    // 加载表格数据
    handleSubmit (params) {
      this.loading = true
      this.$api.opaCustomerLablesListApi({
        ...params || this.params,
        ...this.page
      }).then(res => {
        this.loading = false
        this.page.pageTotal = res.body.count
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
